// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { css } from "styled-components";

/**
 * It's a necessary style that we need for all projects
 */
export const xSwiperStyle = css`
    width: 100%;
    .swiper-slide {
        // to make all slides has the same height
        height: auto;
        // To fix swiper render issue
        margin-top: 1px;
        margin-bottom: 1px;
    }

    // hide swiper arrow navigation and use custom arrow navigation
    .swiper-button-prev,
    .swiper-button-next {
        display: none;
    }
`;
